import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    this.fileInput = this.element.querySelector('input[type="file"]');
    this.radios = this.element.querySelectorAll('input[name="modo_importacion"]');
    this.errorDiv = this.element.querySelector('#modo_importacion_error');
    this.submitBtn = this.element.querySelector('button[type="submit"]');

    this.toggleInputs();
    this.radios.forEach((radio) => {
      radio.addEventListener('change', this.toggleInputs.bind(this));
    });
  }

  toggleInputs() {
    const checked = Array.from(this.radios).some((r) => r.checked);
    if (this.fileInput) this.fileInput.style.display = checked ? '' : 'none';
    if (this.submitBtn) this.submitBtn.style.display = checked ? '' : 'none';
    // Buscar el label asociado al file input
    if (this.fileInput) {
      const fileLabel = this.fileInput.closest('.form-group')?.querySelector('label[for="file"]');
      if (fileLabel) fileLabel.style.display = checked ? '' : 'none';
    }
    // Ocultar el texto de Ficheros permitidos
    const allowedFilesText = this.element.querySelector('.text-center span');
    if (allowedFilesText && allowedFilesText.textContent.includes(':')) {
      allowedFilesText.parentElement.style.display = checked ? '' : 'none';
    }
  }
}
